import { create } from 'zustand'

type LastBoundaryErrorState = {
    lastBoundaryErrorMessage: string | null
    lastBoundaryErrorAt: number | null
    setLastBoundaryError: (message: string) => void
    clearLastBoundaryError: () => void
}

export const useLastBoundaryErrorStore = create<LastBoundaryErrorState>()((set) => ({
    lastBoundaryErrorMessage: null,
    lastBoundaryErrorAt: null,
    setLastBoundaryError: (message) =>
        set({
            lastBoundaryErrorMessage: message,
            lastBoundaryErrorAt: Date.now(),
        }),
    clearLastBoundaryError: () =>
        set({
            lastBoundaryErrorMessage: null,
            lastBoundaryErrorAt: null,
        }),
}))
